import { render, staticRenderFns } from "./FaceCheck.vue?vue&type=template&id=3b7375b8&scoped=true"
import script from "./FaceCheck.vue?vue&type=script&lang=js"
export * from "./FaceCheck.vue?vue&type=script&lang=js"
import style0 from "./FaceCheck.vue?vue&type=style&index=0&id=3b7375b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7375b8",
  null
  
)

export default component.exports